import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ApplicationFacade } from '@shared/data';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';

@Component({
  selector: 'moxi-ride-side-menu',
  imports: [
    RouterModule,

    TranslatePipe,

    // Ant Design
    NzIconModule,
    NzLayoutModule,
    NzMenuModule
  ],
  templateUrl: './ride-side-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RideSideMenuComponent {
  private readonly appFacade = inject(ApplicationFacade);

  isCollapsed = input.required<boolean>();
  accountId = input.required<string>();

  isDispatcher = this.appFacade.isDispatcher;
  isRideBooker = this.appFacade.isRideBooker;
  hasRideBookingService = this.appFacade.hasRideBookingService;
  hasDispatcherService = this.appFacade.hasDispatcherService;

  path = computed(() => `/account/${this.accountId()}/ride`);
}
